import React, { useState } from "react";
import InputField from "../Forms/Input/InputField";

interface Props {
  manualContingencyEnabled: boolean;
  isSubmitting: boolean;
  isLoading: boolean;
  onEnable: (reason: string) => void;
  onDisable: () => void;
}

const DteSystemStatusControls: React.FC<Props> = ({
  manualContingencyEnabled,
  isSubmitting,
  isLoading,
  onEnable,
  onDisable,
}) => {
  const [reason, setReason] = useState("");

  const handleAction = async () => {
    if (!manualContingencyEnabled) {
      onEnable(reason || "Activación manual");
      setReason("");
    } else {
      onDisable();
    }
  };

  return (
    <div className="space-y-6">

      {/* ✍ Motivo solo si estamos por activar contingencia */}
      {!manualContingencyEnabled && (
        <InputField
          label="Motivo de Activación"
          name="reason"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Ej: Hacienda no responde"
          iconKey="edit"
          type="text"
        />
      )}

      {/* 🟣 Botón principal */}
      <button
        onClick={handleAction}
        disabled={isSubmitting || isLoading}
        className={`rounded px-4 py-2 text-white font-medium transition ${
          manualContingencyEnabled
            ? "bg-[#DC3545] hover:bg-opacity-90"
            : "bg-primary hover:bg-opacity-90"
        } disabled:opacity-60`}
      >
        {manualContingencyEnabled ? "Desactivar Contingencia" : "Activar Contingencia"}
      </button>

    </div>
  );
};

export default DteSystemStatusControls;
